import _ from 'lodash'
import { twMerge } from 'tailwind-merge'
import NextLink from 'next/link'
import React from 'react'
import { PlusIcon, PencilSquareIcon } from '@heroicons/react/20/solid'
import { MagnifyingGlassIcon } from '@heroicons/react/24/outline'

const variantStyles = {
  primary: 'btn-primary',
  secondary: 'btn-secondary',
  outline: 'btn-outline',
}

type Props = {
  variant?: keyof typeof variantStyles
  href: string
  label: string | React.ReactNode
  icon?: 'new' | 'edit' | 'view'
} & ((React.ComponentPropsWithoutRef<'a'>))

export function LinkButton({ variant, href, label, icon, className }: Props) {
  className = twMerge(
    'transition duration-300',
    'text-sm font-medium dark:font-normal rounded block px-4 h-10',
    'flex items-center justify-center space-x-1 truncate',
    variantStyles[variant || 'primary'],
    className,
  )
  const Icon = () => {
    switch (icon) {
      case 'new':
        return <PlusIcon className='size-4 mr-1.5 -ml-0.5' />
      case 'edit':
        return <PencilSquareIcon className='size-4 mr-1.5 -ml-0.5' />
      case 'view':
        return <MagnifyingGlassIcon className='size-4 mr-1.5 -ml-0.5' />
      default:
        return <></>
    }
  }
  return (
    <NextLink href={href} className={className} hrefLang='en'>
      <Icon />
      {label}
    </NextLink>
  )
}